<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Edição de unidade externa' : 'Cadastro de unidade externa'">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form :id="id" ref="Form" @save="handleSave" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/cadastro/unidade-externa/Form'

export default {
    components: { Form },
    methods: {
        handleExit() {
            this.$router.push({ name: 'cadastro-unidade-externa-index' })
        },
        handleSave() {
            this.handleExit()
        },
    },
    props: {
        id: { type: Number, default: null }
    }
}
</script>